import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getPropIndexInObject',
})
export class GetPropIndexInObjectPipe implements PipeTransform {
  transform(object: Record<string, unknown>, propName: string): number {
    const index = Object.keys(object).findIndex((item) => item === propName);
    return index || index === 0 ? index + 1 : null;
  }
}
